(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3652],{

/***/ 94188:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ the_growth_report; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(28543);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/components/Media/index.ts + 2 modules
var Media = __webpack_require__(75091);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Section/index.ts + 2 modules
var Section = __webpack_require__(88392);
// EXTERNAL MODULE: ../../libs/templates/NavigationBrand/index.ts + 3 modules
var NavigationBrand = __webpack_require__(22761);
// EXTERNAL MODULE: ../../libs/templates/FooterCompact/index.ts + 2 modules
var FooterCompact = __webpack_require__(69524);
// EXTERNAL MODULE: ../../libs/next-shared/layout/index.ts
var layout = __webpack_require__(56052);
// EXTERNAL MODULE: ../../node_modules/sanitize-html/index.js
var sanitize_html = __webpack_require__(24330);
var sanitize_html_default = /*#__PURE__*/__webpack_require__.n(sanitize_html);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/matcha/components/Divider/index.ts + 1 modules
var Divider = __webpack_require__(76305);
// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./src/views/TheGrowthReport2023/components/OurTake/OurTake.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









var paragraphs = ["In the complicated dance of business growth in 2023, it\u2019s clear that AI is setting the rhythm but data will always choose the tune. Without rich, quality data to guide it, even the most sophisticated AI remains directionless.", "As businesses continue to look for new (and sustainable) ways to find growth opportunities, making sure they have access to the best information to inform their campaigns (in whatever capacity) will be integral to that success.", "Curious about how to get started in corralling, analyzing, and segmenting your own customer data to enhance your AI strategy while delivering better customer experiences?", "A Customer Data Platform can help you with that."];
var copy = {
  overline: "Our Take",
  heading: "Data drives the \u2018AI\u2019-lgorithm of success"
};

var OurTake = function OurTake() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
    id: "ourTake",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSectionBase, {
      variant: "noCopy",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* Contents */.AU, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledCopyTextOverline, {
          tag: "h2",
          variant: "overline",
          children: copy.overline
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledDivider, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledCopyTextHeading, {
          children: copy.heading
        }), paragraphs.map(function (item, index) {
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
            variant: "pSmall",
            dangerouslySetInnerHTML: {
              __html: sanitize_html_default()(item, {
                allowedTags: ["a"]
              })
            }
          }, index);
        })]
      })
    })
  });
};

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1afl61y4"
} : 0)( true ? "" : 0);

var StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e1afl61y3"
} : 0)(Section/* Wrapper */.im, "{padding:0;padding-bottom:8px;}" + ( true ? "" : 0));

var StyledCopyTextOverline = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CopyText/* Overline */.Lh,  true ? {
  target: "e1afl61y2"
} : 0)( true ? {
  name: "dvnwwi",
  styles: "text-transform:none;letter-spacing:0"
} : 0);

var StyledDivider = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Divider/* default */.Z,  true ? {
  target: "e1afl61y1"
} : 0)( true ? {
  name: "92375q",
  styles: "margin:25px 0 0"
} : 0);

var StyledCopyTextHeading = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CopyText/* Heading */.X6,  true ? {
  target: "e1afl61y0"
} : 0)( true ? {
  name: "de9hf",
  styles: "padding-top:16px"
} : 0);

/* harmony default export */ var OurTake_OurTake = (OurTake);
;// CONCATENATED MODULE: ./src/views/TheGrowthReport2023/components/Methodology/Methodology.tsx


function Methodology_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









var PARAGRAPH = "<strong>Disclaimer:</strong> This report contains statistical data, estimates, and expectations that are based on publicly available information, as well as other information based on our internal sources or collected through our commercial relationships. These do not represent, and should not be construed as indicators of Twilio\u2019s historical or future financial performance or the actual or potential demand for Twilio's products and solutions, and such information is solely presented as context for broader market trends.";
var list = ["Twilio Segment conducted this research using an online survey prepared by <a href=\"https://www.methodcommunications.com/methodresearch/\">Method Research</a> and distributed by <a href=\"https://www.cint.com/\">Cint</a> among n=2,450 full-time employees familiar with the company\u2019s growth strategy working in marketing, engineering, UX, product, and customer services roles at B2B companies with 75+ employees.", "The sample consisted of n=1,000 respondents from the United States, n=300 from each of the United Kingdom, Brazil, Germany, and France; and n=250 from Australia. Data was collected from August 3 to August 30, 2023."];
var Methodology_copy = {
  overline: "Methodology"
};

var Methodology = function Methodology() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Methodology_Wrapper, {
    id: "methodology",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Methodology_StyledSectionBase, {
      variant: "noCopy",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* Contents */.AU, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Methodology_StyledCopyTextOverline, {
          tag: "h2",
          variant: "overline",
          children: Methodology_copy.overline
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Methodology_StyledDivider, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ul", {
          children: list.map(function (item, index) {
            return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
              variant: "pSmall",
              tag: "li",
              dangerouslySetInnerHTML: {
                __html: sanitize_html_default()(item, {
                  allowedTags: ["a"]
                })
              }
            }, index);
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
          variant: "pSmall",
          dangerouslySetInnerHTML: {
            __html: sanitize_html_default()(PARAGRAPH, {
              allowedTags: ["strong"]
            })
          }
        })]
      })
    })
  });
};

var Methodology_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e3wu8y23"
} : 0)( true ? "" : 0);

var Methodology_StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e3wu8y22"
} : 0)(Section/* Wrapper */.im, "{padding:0;}" + ( true ? "" : 0));

var Methodology_StyledCopyTextOverline = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CopyText/* Overline */.Lh,  true ? {
  target: "e3wu8y21"
} : 0)( true ? {
  name: "dvnwwi",
  styles: "text-transform:none;letter-spacing:0"
} : 0);

var Methodology_StyledDivider = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Divider/* default */.Z,  true ? {
  target: "e3wu8y20"
} : 0)( true ? {
  name: "92375q",
  styles: "margin:25px 0 0"
} : 0);

/* harmony default export */ var Methodology_Methodology = (Methodology);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Hero/index.tsx + 2 modules
var recipes_Hero = __webpack_require__(84629);
// EXTERNAL MODULE: ../../libs/templates/Forms/EmailCaptureForm/index.ts + 3 modules
var EmailCaptureForm = __webpack_require__(41948);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ./src/views/TheGrowthReport2023/components/Hero/assets/Hero@2x.png
var Hero_2x = __webpack_require__(85045);
var Hero_2x_default = /*#__PURE__*/__webpack_require__.n(Hero_2x);
// EXTERNAL MODULE: ./src/views/TheGrowthReport2023/components/Hero/assets/Hero.webp
var assets_Hero = __webpack_require__(14210);
var Hero_default = /*#__PURE__*/__webpack_require__.n(assets_Hero);
// EXTERNAL MODULE: ./src/views/TheGrowthReport2023/components/Hero/assets/Hero@2x.webp
var assets_Hero_2x = __webpack_require__(32719);
var assets_Hero_2x_default = /*#__PURE__*/__webpack_require__.n(assets_Hero_2x);
;// CONCATENATED MODULE: ./src/views/TheGrowthReport2023/components/Hero/Hero.tsx


function Hero_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }












var Hero_copy = {
  title: "The Growth Report 2023: AI edition",
  description: "Brought to you by Twilio Segment"
};
var Hero_form = {
  customFormIdentifier: "cnt-growthreport-2023-download",
  additionalTrackEvent: "Content Downloaded",
  buttonText: "Download the Growth Report",
  buttonUrl: "/pdfs/Twilio-Segment-Growth-Report-2023.pdf",
  overrideConsent: true
};

var Hero = function Hero() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();

  var _useState = (0,react.useState)(false),
      isSubmitted = _useState[0],
      setIsSubmitted = _useState[1];

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Hero_Wrapper, {
    id: "heroForm",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledHeroBase, {
      variant: "2Col",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(recipes_Hero/* Copy */.CK, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            tag: "h1",
            variant: "h1",
            children: Hero_copy.title
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
            tag: "p",
            variant: "pLarge",
            children: Hero_copy.description
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormWrapper, {
          variant: isSubmitted ? "wide" : "narrow",
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmailCaptureForm/* default */.Z, {
            resourceType: "report",
            customFormIdentifier: Hero_form.customFormIdentifier,
            additionalTrackEvent: Hero_form.additionalTrackEvent,
            overrideConsent: Hero_form.overrideConsent,
            buttonText: Hero_form.buttonText,
            successButtonText: Hero_form.buttonText,
            buttonUrl: (0,getAbsoluteUrl/* default */.Z)(Hero_form.buttonUrl, pageConfig),
            onSubmit: function onSubmit() {
              return setIsSubmitted(true);
            },
            enableJobTitleField: true
          })
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Hero/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
            type: "image/webp",
            srcSet: "".concat((Hero_default()), ", ").concat((assets_Hero_2x_default()), " 2x")
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Hero/* Image */.Ee, {
            src: (Hero_2x_default()),
            width: "640",
            height: "427",
            alt: "Illustration: The Growth Report"
          })]
        })
      })]
    })
  });
};

var Hero_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("header",  true ? {
  target: "e1tixmg22"
} : 0)("background-color:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.twilio.gray[10];
}, ";" + ( true ? "" : 0));

var StyledHeroBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(recipes_Hero/* default */.ZP,  true ? {
  target: "e1tixmg21"
} : 0)( true ? {
  name: "bjn8wh",
  styles: "position:relative"
} : 0);

var FormWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1tixmg20"
} : 0)("margin-top:38px;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("lg");
}, "{max-width:", function (_ref3) {
  var variant = _ref3.variant;
  return variant === "narrow" ? "417px" : "unset";
}, ";margin-top:48px;}" + ( true ? "" : 0));

/* harmony default export */ var Hero_Hero = (Hero);
;// CONCATENATED MODULE: ./src/views/TheGrowthReport2023/components/Introduction/Introduction.tsx


function Introduction_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }








var Introduction_paragraphs = ["Twilio Segment\u2019s third annual Growth Report is a yearly exploration of the tools, technology, and techniques businesses are using to grow in 2023. This year, It should surprise no one that one trend came through in our survey loud and clear \u2013 the rise of AI.", "We saw an unprecedented level of AI adoption, and real business impact being achieved. Additionally, as AI becomes more deeply rooted within organizations, more advanced strategies are being leveraged to maximize its potential.", "In this year\u2019s Growth Report, we surveyed 2,450 marketing, CX, and data leaders from across industries to explore what it means to grow sustainably in 2023, and how companies are using AI to do just that."];
var Introduction_copy = {
  overline: "Introduction",
  heading: "More than meets the AI"
};

var Introduction = function Introduction() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Introduction_Wrapper, {
    id: "introduction",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Introduction_StyledSectionBase, {
      variant: "noCopy",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* Contents */.AU, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Introduction_StyledCopyTextOverline, {
          tag: "h2",
          variant: "overline",
          children: Introduction_copy.overline
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Introduction_StyledDivider, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Introduction_StyledCopyTextHeading, {
          children: Introduction_copy.heading
        }), Introduction_paragraphs.map(function (item, index) {
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
            variant: "pSmall",
            children: item
          }, index);
        })]
      })
    })
  });
};

var Introduction_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eiztmwj4"
} : 0)( true ? "" : 0);

var Introduction_StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "eiztmwj3"
} : 0)(Section/* Wrapper */.im, "{padding:0;padding-bottom:56px;}" + ( true ? "" : 0));

var Introduction_StyledCopyTextOverline = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CopyText/* Overline */.Lh,  true ? {
  target: "eiztmwj2"
} : 0)( true ? {
  name: "dvnwwi",
  styles: "text-transform:none;letter-spacing:0"
} : 0);

var Introduction_StyledDivider = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Divider/* default */.Z,  true ? {
  target: "eiztmwj1"
} : 0)( true ? {
  name: "92375q",
  styles: "margin:25px 0 0"
} : 0);

var Introduction_StyledCopyTextHeading = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CopyText/* Heading */.X6,  true ? {
  target: "eiztmwj0"
} : 0)( true ? {
  name: "de9hf",
  styles: "padding-top:16px"
} : 0);

/* harmony default export */ var Introduction_Introduction = (Introduction);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../libs/matcha/components/Image/index.ts + 2 modules
var Image = __webpack_require__(4203);
// EXTERNAL MODULE: ./src/views/TheGrowthReport2023/components/KeyFindings/assets/section1/Frame.png
var Frame = __webpack_require__(71236);
var Frame_default = /*#__PURE__*/__webpack_require__.n(Frame);
// EXTERNAL MODULE: ./src/views/TheGrowthReport2023/components/KeyFindings/assets/section1/Frame.webp
var section1_Frame = __webpack_require__(53583);
var section1_Frame_default = /*#__PURE__*/__webpack_require__.n(section1_Frame);
// EXTERNAL MODULE: ./src/views/TheGrowthReport2023/components/KeyFindings/assets/section1/Frame2.png
var Frame2 = __webpack_require__(39584);
var Frame2_default = /*#__PURE__*/__webpack_require__.n(Frame2);
// EXTERNAL MODULE: ./src/views/TheGrowthReport2023/components/KeyFindings/assets/section1/Frame2.webp
var section1_Frame2 = __webpack_require__(45500);
var section1_Frame2_default = /*#__PURE__*/__webpack_require__.n(section1_Frame2);
// EXTERNAL MODULE: ./src/views/TheGrowthReport2023/components/KeyFindings/assets/section1/FrameMobile.png
var FrameMobile = __webpack_require__(2313);
var FrameMobile_default = /*#__PURE__*/__webpack_require__.n(FrameMobile);
// EXTERNAL MODULE: ./src/views/TheGrowthReport2023/components/KeyFindings/assets/section1/FrameMobile.webp
var section1_FrameMobile = __webpack_require__(64609);
var section1_FrameMobile_default = /*#__PURE__*/__webpack_require__.n(section1_FrameMobile);
// EXTERNAL MODULE: ./src/views/TheGrowthReport2023/components/KeyFindings/assets/section1/Frame2Mobile.png
var Frame2Mobile = __webpack_require__(18955);
var Frame2Mobile_default = /*#__PURE__*/__webpack_require__.n(Frame2Mobile);
// EXTERNAL MODULE: ./src/views/TheGrowthReport2023/components/KeyFindings/assets/section1/Frame2Mobile.webp
var section1_Frame2Mobile = __webpack_require__(65752);
var section1_Frame2Mobile_default = /*#__PURE__*/__webpack_require__.n(section1_Frame2Mobile);
// EXTERNAL MODULE: ./src/views/TheGrowthReport2023/components/KeyFindings/assets/section2/Frame.png
var section2_Frame = __webpack_require__(88173);
var section2_Frame_default = /*#__PURE__*/__webpack_require__.n(section2_Frame);
// EXTERNAL MODULE: ./src/views/TheGrowthReport2023/components/KeyFindings/assets/section2/FrameMobile.png
var section2_FrameMobile = __webpack_require__(71463);
var section2_FrameMobile_default = /*#__PURE__*/__webpack_require__.n(section2_FrameMobile);
// EXTERNAL MODULE: ./src/views/TheGrowthReport2023/components/KeyFindings/assets/section2/Frame.webp
var assets_section2_Frame = __webpack_require__(56150);
var assets_section2_Frame_default = /*#__PURE__*/__webpack_require__.n(assets_section2_Frame);
// EXTERNAL MODULE: ./src/views/TheGrowthReport2023/components/KeyFindings/assets/section2/FrameMobile.webp
var assets_section2_FrameMobile = __webpack_require__(14248);
var assets_section2_FrameMobile_default = /*#__PURE__*/__webpack_require__.n(assets_section2_FrameMobile);
// EXTERNAL MODULE: ./src/views/TheGrowthReport2023/components/KeyFindings/assets/section3/Frame.png
var section3_Frame = __webpack_require__(43077);
var section3_Frame_default = /*#__PURE__*/__webpack_require__.n(section3_Frame);
// EXTERNAL MODULE: ./src/views/TheGrowthReport2023/components/KeyFindings/assets/section3/FrameMobile.png
var section3_FrameMobile = __webpack_require__(89860);
var section3_FrameMobile_default = /*#__PURE__*/__webpack_require__.n(section3_FrameMobile);
// EXTERNAL MODULE: ./src/views/TheGrowthReport2023/components/KeyFindings/assets/section3/Frame.webp
var assets_section3_Frame = __webpack_require__(17235);
var assets_section3_Frame_default = /*#__PURE__*/__webpack_require__.n(assets_section3_Frame);
// EXTERNAL MODULE: ./src/views/TheGrowthReport2023/components/KeyFindings/assets/section3/FrameMobile.webp
var assets_section3_FrameMobile = __webpack_require__(65947);
var assets_section3_FrameMobile_default = /*#__PURE__*/__webpack_require__.n(assets_section3_FrameMobile);
// EXTERNAL MODULE: ./src/views/TheGrowthReport2023/components/KeyFindings/assets/section4/Frame.png
var section4_Frame = __webpack_require__(73304);
var section4_Frame_default = /*#__PURE__*/__webpack_require__.n(section4_Frame);
// EXTERNAL MODULE: ./src/views/TheGrowthReport2023/components/KeyFindings/assets/section4/Frame.webp
var assets_section4_Frame = __webpack_require__(30475);
var assets_section4_Frame_default = /*#__PURE__*/__webpack_require__.n(assets_section4_Frame);
// EXTERNAL MODULE: ./src/views/TheGrowthReport2023/components/KeyFindings/assets/section4/Frame2.png
var section4_Frame2 = __webpack_require__(8164);
var section4_Frame2_default = /*#__PURE__*/__webpack_require__.n(section4_Frame2);
// EXTERNAL MODULE: ./src/views/TheGrowthReport2023/components/KeyFindings/assets/section4/Frame2.webp
var assets_section4_Frame2 = __webpack_require__(32178);
var assets_section4_Frame2_default = /*#__PURE__*/__webpack_require__.n(assets_section4_Frame2);
// EXTERNAL MODULE: ./src/views/TheGrowthReport2023/components/KeyFindings/assets/section4/FrameMobile.png
var section4_FrameMobile = __webpack_require__(62072);
var section4_FrameMobile_default = /*#__PURE__*/__webpack_require__.n(section4_FrameMobile);
// EXTERNAL MODULE: ./src/views/TheGrowthReport2023/components/KeyFindings/assets/section4/FrameMobile.webp
var assets_section4_FrameMobile = __webpack_require__(16522);
var assets_section4_FrameMobile_default = /*#__PURE__*/__webpack_require__.n(assets_section4_FrameMobile);
// EXTERNAL MODULE: ./src/views/TheGrowthReport2023/components/KeyFindings/assets/section4/Frame2Mobile.png
var section4_Frame2Mobile = __webpack_require__(11455);
var section4_Frame2Mobile_default = /*#__PURE__*/__webpack_require__.n(section4_Frame2Mobile);
// EXTERNAL MODULE: ./src/views/TheGrowthReport2023/components/KeyFindings/assets/section4/Frame2Mobile.webp
var assets_section4_Frame2Mobile = __webpack_require__(5080);
var assets_section4_Frame2Mobile_default = /*#__PURE__*/__webpack_require__.n(assets_section4_Frame2Mobile);
;// CONCATENATED MODULE: ./src/views/TheGrowthReport2023/components/KeyFindings/data.tsx
/** Section 1 */








/* Section 2 */





/* Section 3 */





/* Section 4 */









var items = [{
  key: 0,
  heading: "AI is officially everywhere",
  description: ["Despite the uncertain economic landscape, there\u2019s still an appetite to try new things, especially if those new things (ahem, AI) have proven results. Some examples of what businesses are spending money on? Efficiency. Personalization. Scalability.", "When it comes to tech that delivers results across a variety of use cases, AI seems to fit the bill. And businesses are budgeting for it."],
  images: [{
    src: (Frame_default()),
    src2x: (Frame_default()),
    webp: (section1_Frame_default()),
    webp2x: (section1_Frame_default()),
    height: 463,
    width: 844,
    mobile: {
      src: (FrameMobile_default()),
      src2x: (FrameMobile_default()),
      webp: (section1_FrameMobile_default()),
      webp2x: (section1_FrameMobile_default())
    },
    alt: "Nearly half of businesses (48%) expect to spend more on AI-driven campaigns in the next 12 months. 56% of businesses will increase spending on marketing technology in the next year"
  }, {
    src: (Frame2_default()),
    src2x: (Frame2_default()),
    webp: (section1_Frame2_default()),
    webp2x: (section1_Frame2_default()),
    height: 463,
    width: 844,
    mobile: {
      src: (Frame2Mobile_default()),
      src2x: (Frame2Mobile_default()),
      webp: (section1_Frame2Mobile_default()),
      webp2x: (section1_Frame2Mobile_default())
    },
    alt: "Only 6% say they expect to decrease their spending on marketing technology, a substantial drop from 2022 when 38% of professionals said the same"
  }]
}, {
  key: 1,
  heading: "AI is changing the marketing game, specifically with chatbots and personalized product recommendations",
  description: ["You get a chatbot! You get a chatbot! Oprah memes aside, businesses are betting big on how to use AI in channels that are already providing the most ROI for their customers.", "For both website and social, this means personalization driven by thousands of unique customer journeys that AI can build in mere seconds \u2013 enhancing copy, segmentations, and A/B testing faster than ever before."],
  images: [{
    src: (section2_Frame_default()),
    src2x: (section2_Frame_default()),
    webp: (assets_section2_Frame_default()),
    webp2x: (assets_section2_Frame_default()),
    height: 463,
    width: 844,
    mobile: {
      src: (section2_FrameMobile_default()),
      src2x: (section2_FrameMobile_default()),
      webp: (assets_section2_FrameMobile_default()),
      webp2x: (assets_section2_FrameMobile_default())
    },
    alt: "More than three-quarters of respondents (76%) are experimenting with AI on their marketing channels with websites and social media being the biggest places for disruption. 82% of businesses will be using some form of AI automation in their marketing efforts this year"
  }]
}, {
  key: 2,
  heading: "Do more with less: AI means more time and more money",
  description: ["The trend of businesses amplifying their investment in AI signifies more than just a passing inclination.", "While 46% of businesses think AI is delivering time savings for their business, they're also betting on it delivering real ROI as well. 37% also believe integrating AI into their marketing campaigns could be the catalyst for tangible financial savings."],
  images: [{
    src: (section3_Frame_default()),
    src2x: (section3_Frame_default()),
    webp: (assets_section3_Frame_default()),
    webp2x: (assets_section3_Frame_default()),
    height: 463,
    width: 844,
    mobile: {
      src: (section3_FrameMobile_default()),
      src2x: (section3_FrameMobile_default()),
      webp: (assets_section3_FrameMobile_default()),
      webp2x: (assets_section3_FrameMobile_default())
    },
    alt: "60% of businesses are adopting a \u2018do more with less\u2019 mentality when it comes to tools and technology. 58% believe that customers will welcome the use of AI in their marketing efforts if it delivers better service and experiences"
  }]
}, {
  key: 3,
  heading: "The key to unlocking AI? Quality data",
  description: ["The transformative impact of AI on the business landscape is undeniable. However, the true potential of AI in driving growth hinges on the quality of the data it processes.", "Given how many businesses are prioritizing first-party data in the coming year, it goes without saying that businesses will continue to need to do so as they also integrate AI efforts."],
  images: [{
    src: (section4_Frame_default()),
    src2x: (section4_Frame_default()),
    webp: (assets_section4_Frame_default()),
    webp2x: (assets_section4_Frame_default()),
    height: 463,
    width: 844,
    mobile: {
      src: (section4_FrameMobile_default()),
      src2x: (section4_FrameMobile_default()),
      webp: (assets_section4_FrameMobile_default()),
      webp2x: (assets_section4_FrameMobile_default())
    },
    alt: "65% of businesses say quality, accurate data is one of the most important ingredients for growth. 65% of respondents feel like AI could be more useful with access to higher-quality data."
  }, {
    src: (section4_Frame2_default()),
    src2x: (section4_Frame2_default()),
    webp: (assets_section4_Frame2_default()),
    webp2x: (assets_section4_Frame2_default()),
    height: 463,
    width: 844,
    mobile: {
      src: (section4_Frame2Mobile_default()),
      src2x: (section4_Frame2Mobile_default()),
      webp: (assets_section4_Frame2Mobile_default()),
      webp2x: (assets_section4_Frame2Mobile_default())
    },
    alt: "81% of businesses are prioritizing capturing and leveraging first-party data better in the coming year; more than the 71% who said the same in 2022"
  }]
}];
;// CONCATENATED MODULE: ./src/views/TheGrowthReport2023/components/KeyFindings/KeyFindings.tsx


var _excluded = ["key"];

function KeyFindings_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }











var KeyFindings_copy = {
  overline: "Key Findings"
};

var KeyFindings = function KeyFindings() {
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(KeyFindings_Wrapper, {
    id: "keyFindings",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(KeyFindings_StyledSectionBase, {
      variant: "noCopy",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* Contents */.AU, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(KeyFindings_StyledCopyTextOverline, {
          tag: "h2",
          variant: "overline",
          children: KeyFindings_copy.overline
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(KeyFindings_StyledDivider, {}), items.map(function (_ref) {
          var _itemProps$images;

          var key = _ref.key,
              itemProps = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

          return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyTextWrapper, {
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
              children: itemProps.heading
            }), itemProps.description.map(function (description, descIndex) {
              return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
                variant: "pSmall",
                children: description
              }, "".concat(descIndex, "-").concat(key));
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ImageWrapper, {
              imagesNumber: itemProps.images.length,
              children: (_itemProps$images = itemProps.images) === null || _itemProps$images === void 0 ? void 0 : _itemProps$images.map(function (_ref2, index) {
                var src = _ref2.src,
                    webp = _ref2.webp,
                    webp2x = _ref2.webp2x,
                    mobile = _ref2.mobile,
                    height = _ref2.height,
                    width = _ref2.width,
                    alt = _ref2.alt;
                return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
                  children: [mobile && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
                      media: theme.breakpoints.down("sm", false),
                      srcSet: "".concat(mobile.src, ", ").concat(mobile.src2x, " 2x")
                    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
                      media: theme.breakpoints.down("sm", false),
                      type: "image/webp",
                      srcSet: "".concat(mobile.webp, ", ").concat(mobile.webp2x, " 2x")
                    })]
                  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
                    type: "image/webp",
                    srcSet: "".concat(webp, ", ").concat(webp2x, " 2x")
                  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledImage, {
                    width: width,
                    height: height,
                    src: src,
                    alt: alt || "Illustration",
                    loading: "lazy"
                  })]
                }, index);
              })
            })]
          }, key);
        })]
      })
    })
  });
};

var KeyFindings_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e3un6u76"
} : 0)( true ? "" : 0);

var KeyFindings_StyledCopyTextOverline = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CopyText/* Overline */.Lh,  true ? {
  target: "e3un6u75"
} : 0)( true ? {
  name: "dvnwwi",
  styles: "text-transform:none;letter-spacing:0"
} : 0);

var KeyFindings_StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e3un6u74"
} : 0)(Section/* Wrapper */.im, "{padding:0;padding-bottom:24px;}" + ( true ? "" : 0));

var CopyTextWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e3un6u73"
} : 0)( true ? {
  name: "1j03bg4",
  styles: "padding-top:16px;padding-bottom:40px"
} : 0);

var KeyFindings_StyledDivider = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Divider/* default */.Z,  true ? {
  target: "e3un6u72"
} : 0)( true ? {
  name: "92375q",
  styles: "margin:25px 0 0"
} : 0);

var ImageWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e3un6u71"
} : 0)("padding-top:", function (_ref3) {
  var imagesNumber = _ref3.imagesNumber;
  return imagesNumber > 0 ? "32px" : "0";
}, ";display:grid;grid-template-rows:", function (_ref4) {
  var imagesNumber = _ref4.imagesNumber;
  return "1fr ".repeat(imagesNumber);
}, ";row-gap:48px;" + ( true ? "" : 0));

var StyledImage = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Image/* default */.Z,  true ? {
  target: "e3un6u70"
} : 0)(function (_ref5) {
  var theme = _ref5.theme;
  return theme.breakpoints.down("sm");
}, "{max-width:320px;}" + ( true ? "" : 0));

/* harmony default export */ var KeyFindings_KeyFindings = (KeyFindings);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/matcha/recipes/SignupButton/index.ts
var SignupButton = __webpack_require__(77931);
;// CONCATENATED MODULE: ./src/views/TheGrowthReport2023/components/Signup/Signup.tsx


/* eslint-disable camelcase */








var Signup_copy = {
  heading: "Sign up for a free trial today, or chat with a member of our team to find out what a CDP can deliver for your business.",
  button: {
    text: "Create a free account"
  },
  demoButton: {
    text: "Get a demo",
    href: "/demo/?utm_source=ebook&utm_medium=referral&utm_campaign=all_cnt_2023-10-17-cnt-growth-report_20231017&utm_content=ebook"
  }
};

var Signup = function Signup() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Signup_Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Signup_StyledSectionBase, {
      variant: "noCopy",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* Contents */.AU, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          variant: "h4",
          children: Signup_copy.heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Buttons, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
            size: "large",
            tag: "a",
            href: (0,getAbsoluteUrl/* default */.Z)(Signup_copy.demoButton.href, pageConfig),
            variant: "filled",
            color: "primary",
            children: Signup_copy.demoButton.text
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SignupButton/* default */.Z, {
            tag: "a",
            variant: "outlined",
            additionalParams: {
              utm_source: "ebook",
              utm_medium: "referral",
              utm_campaign: "all_cnt_2023-10-17-cnt-growth-report_20231017",
              utm_content: "ebook"
            },
            children: Signup_copy.button.text
          })]
        })]
      })
    })
  });
};

var Signup_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ecviiog2"
} : 0)( true ? "" : 0);

var Buttons = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ecviiog1"
} : 0)("display:grid;max-width:520px;width:100%;grid-template-columns:auto auto;grid-template-rows:auto;gap:24px;", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.down("sm");
}, "{grid-template-columns:auto;}" + ( true ? "" : 0));

var Signup_StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "ecviiog0"
} : 0)(Section/* Wrapper */.im, "{padding:0;padding-bottom:80px;}" + ( true ? "" : 0));

/* harmony default export */ var Signup_Signup = (Signup);
// EXTERNAL MODULE: ../../libs/matcha/components/ButtonText/index.ts
var ButtonText = __webpack_require__(74870);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Common.ts + 14 modules
var Common = __webpack_require__(6580);
// EXTERNAL MODULE: ../../libs/matcha/recipes/TableOfContents/index.ts + 8 modules
var TableOfContents = __webpack_require__(55979);
// EXTERNAL MODULE: ../../libs/utils/useScrollToAnchor/index.ts
var useScrollToAnchor = __webpack_require__(68714);
;// CONCATENATED MODULE: ./src/views/TheGrowthReport2023/components/SectionNav/SectionNav.tsx


function SectionNav_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }










var tableOfContents = [{
  id: "introduction",
  label: "Introduction"
}, {
  id: "keyFindings",
  label: "Key Findings"
}, {
  id: "ourTake",
  label: "Our Take"
}, {
  id: "methodology",
  label: "Methodology"
}];
var BUTON_TEXT = "Download the full report";

var SectionNav = function SectionNav() {
  var _useState = (0,react.useState)("introduction"),
      activeTableItem = _useState[0],
      setActiveTableItem = _useState[1];

  var _useState2 = (0,react.useState)(""),
      precedenceOnClick = _useState2[0],
      setPrecedenceOnClick = _useState2[1];

  var _useTableOfContents = (0,TableOfContents/* useTableOfContents */.e9)({
    ids: tableOfContents.map(function (el) {
      return el.id;
    })
  }),
      activeElementId = _useTableOfContents.activeElementId;

  var handleSideBarItemClick = function handleSideBarItemClick(id) {
    setPrecedenceOnClick(id);
    setActiveTableItem(id);
    (0,useScrollToAnchor/* scrollToAnchor */.d)(id, -100);
  };

  var handleScrollEnd = (0,react.useCallback)(function () {
    if (activeElementId && !precedenceOnClick) {
      setActiveTableItem(activeElementId);
    }

    setPrecedenceOnClick(""); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeElementId]);
  (0,react.useEffect)(function () {
    window.addEventListener("scrollend", handleScrollEnd);
    return function () {
      window.removeEventListener("scrollend", handleScrollEnd);
    };
  }, [handleScrollEnd]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StickyContainer, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* Sticky */.Le, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TableOfContents/* default */.ZP, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TableOfContents/* Title */.Dx, {
          children: "Jump to section"
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TableOfContents/* List */.aV, {
          children: tableOfContents.map(function (item) {
            return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TableOfContents/* ListItem */.HC, {
              active: item.id === activeTableItem,
              onClick: function onClick() {
                return handleSideBarItemClick(item.id);
              },
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TableOfContents/* LeftContent */.PJ, {
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TableOfContents/* Text */.xv, {
                  variant: "pSmall",
                  children: item.label
                })
              })
            }, item.id);
          })
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonWrapper, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonText/* default */.Z, {
          iconEnd: Common/* ChevronRightIcon */.XC,
          onClick: function onClick() {
            return (0,useScrollToAnchor/* scrollToAnchor */.d)("heroForm", -100);
          },
          children: BUTON_TEXT
        })
      })]
    })
  });
};

var ButtonWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e43oc9w1"
} : 0)( true ? {
  name: "j3we6u",
  styles: "padding-top:40px"
} : 0);

var StickyContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e43oc9w0"
} : 0)( true ? {
  name: "1wv4onu",
  styles: "position:relative;height:100%"
} : 0);

/* harmony default export */ var SectionNav_SectionNav = (SectionNav);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../libs/matcha/components/Select/index.ts + 9 modules
var Select = __webpack_require__(44502);
// EXTERNAL MODULE: ../../libs/matcha/components/Input/index.ts + 2 modules
var Input = __webpack_require__(94261);
// EXTERNAL MODULE: ../../libs/matcha/components/Select/useSelect/index.ts + 3 modules
var useSelect = __webpack_require__(27431);
;// CONCATENATED MODULE: ./src/views/TheGrowthReport2023/components/MobileSelect/MobileSelect.tsx



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }










var options = [{
  value: "introduction",
  text: "Introduction"
}, {
  value: "keyFindings",
  text: "Key Findings"
}, {
  value: "ourTake",
  text: "Our take"
}, {
  value: "methodology",
  text: "Methodology"
}];

var MobileSelect = function MobileSelect() {
  var _useState = (0,react.useState)("jump"),
      categoryId = _useState[0],
      setCategoryId = _useState[1];

  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  var option = (0,react.useMemo)(function () {
    var _options$find;

    return (_options$find = options.find(function (o) {
      return o.value === categoryId;
    })) !== null && _options$find !== void 0 ? _options$find : {
      value: "jump",
      text: "Jump to section"
    };
  }, [categoryId]);

  var useControlledState = function useControlledState(state) {
    return _objectSpread(_objectSpread({}, state), {}, {
      selected: [option]
    });
  };

  var _useSelect = (0,useSelect/* default */.Z)({
    initialSelected: [option],
    useControlledState: useControlledState,
    options: options,
    id: "jump-to-section",
    onSelect: function onSelect(o) {
      (0,useScrollToAnchor/* scrollToAnchor */.d)(o[0].value, -100);
      setCategoryId(o[0].value);
    },
    config: {
      mobileConfirmationBehaviour: false
    },
    label: "Jump to section"
  }),
      state = _useSelect.state,
      getControlProps = _useSelect.getControlProps,
      filteredOptions = _useSelect.filteredOptions,
      getSelectProps = _useSelect.getSelectProps;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MobileSelect_Wrapper, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Input/* default */.Z, _objectSpread({
      name: "jump-to-section",
      type: "search",
      resetable: state.filterValue !== "",
      expanded: true,
      clearIcon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Select/* ClearSelect */.kr, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Common/* ClearIcon */.Rk, {
          size: "small",
          color: theme.palette.neutrals.white[100]
        })
      }),
      rightSecondIcon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Common/* ChevronDownIcon */.v4, {})
    }, getControlProps({
      placeholder: "Jump to section..."
    }))), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Select/* default */.ZP, _objectSpread({
      id: "sections-dropdown",
      name: "select-section",
      options: options,
      filteredOptions: filteredOptions,
      displayMode: state.displayMode,
      open: state.open,
      modalHeadline: "Jump to section"
    }, getSelectProps()))]
  });
};

var MobileSelect_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e786x30"
} : 0)( true ? "" : 0);

/* harmony default export */ var MobileSelect_MobileSelect = (MobileSelect);
// EXTERNAL MODULE: ./src/views/TheGrowthReport2023/assets/OgGrowthReport.png
var OgGrowthReport = __webpack_require__(49534);
var OgGrowthReport_default = /*#__PURE__*/__webpack_require__.n(OgGrowthReport);
;// CONCATENATED MODULE: ./src/views/TheGrowthReport2023/TheGrowthReport.tsx




















var TheGrowthReportView = function TheGrowthReportView() {
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: "twilioLight",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(layout/* default */.Z, {
      pageTitle: "The Growth Report: The AI Edition | Twilio Segment",
      pageDescription: "Twilio Segment\u2019s third annual Growth Report is a yearly exploration of the tools, technology, and techniques businesses are using to grow in 2023.",
      pageOG: (OgGrowthReport_default()),
      themeColor: theme.palette.neutrals.white[100],
      bodyBackground: theme.palette.neutrals.white[100],
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavigationBrand/* default */.Z, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Main, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Background, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Hero_Hero, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledSection, {
            variant: "sidebar",
            sidebarSize: "small",
            sticky: true,
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Media/* default */.Z, {
              greaterThanOrEqual: "xl",
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionNav_SectionNav, {})
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Media/* default */.Z, {
              lessThan: "xl",
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileSelect_MobileSelect, {})
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* Contents */.AU, {
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Introduction_Introduction, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(KeyFindings_KeyFindings, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OurTake_OurTake, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Signup_Signup, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Methodology_Methodology, {})]
            })]
          })]
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterCompact/* default */.Z, {
        divider: true,
        backgroundColor: theme.palette.neutrals.white[100]
      })]
    })
  });
};

var Main = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("main",  true ? {
  target: "eb82ocu2"
} : 0)( true ? "" : 0);

var Background = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eb82ocu1"
} : 0)("background-color:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.neutrals.white[100];
}, ";" + ( true ? "" : 0));

var StyledSection = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "eb82ocu0"
} : 0)(Section/* Sticky */.Le, "{top:144px;}" + ( true ? "" : 0));

/* harmony default export */ var TheGrowthReport2023_TheGrowthReport = (TheGrowthReportView);
;// CONCATENATED MODULE: ./src/pages/the-growth-report/index.tsx



var TheGrowthReport = function TheGrowthReport() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TheGrowthReport2023_TheGrowthReport, {});
};

/* harmony default export */ var the_growth_report = (TheGrowthReport);

/***/ }),

/***/ 33445:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Button__WEBPACK_IMPORTED_MODULE_0__.z; },
/* harmony export */   "l": function() { return /* reexport safe */ _Button__WEBPACK_IMPORTED_MODULE_0__.l; }
/* harmony export */ });
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62073);


/***/ }),

/***/ 90629:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ UtilityNav_UtilityNav; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(28543);
// EXTERNAL MODULE: ../../libs/utils/useMatchMedia/index.ts + 1 modules
var useMatchMedia = __webpack_require__(61093);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/UtilityNav/useUtilityNavDescriptions.tsx




var useUtilityNavDescriptions = function useUtilityNavDescriptions(descriptions) {
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  var keys = (0,react.useMemo)(function () {
    if (!descriptions) return [];
    return Object.keys(descriptions);
  }, [descriptions]);
  var breakpointsKeys = Object.keys(theme.breakpoints.values);
  var sortedArrayOfKeys = (0,react.useMemo)(function () {
    return breakpointsKeys.filter(function (main) {
      return keys.some(function (key) {
        return key === main;
      });
    });
  }, [breakpointsKeys, keys]);

  var getNextKey = function getNextKey(key, index) {
    if (sortedArrayOfKeys[index - 1]) {
      var getIndexofCurrentKey = breakpointsKeys.indexOf(key);

      if (breakpointsKeys[getIndexofCurrentKey - 1] !== sortedArrayOfKeys[index - 1]) {
        return breakpointsKeys[breakpointsKeys.indexOf(key) - 1];
      }
    }

    return false;
  };

  var array = sortedArrayOfKeys.map(function (key, index) {
    var nextKey = getNextKey(key, index);
    var minWidth = sortedArrayOfKeys[index - 1] ? " and ".concat(theme.breakpoints.up(nextKey ? nextKey : key, false)) : "";
    var mediaString = "".concat(theme.breakpoints.down(key, false)).concat(minWidth);
    return (0,useMatchMedia/* default */.Z)(mediaString, true);
  });
  return descriptions[sortedArrayOfKeys[array.indexOf(true)]];
};

/* harmony default export */ var UtilityNav_useUtilityNavDescriptions = (useUtilityNavDescriptions);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
// EXTERNAL MODULE: ../../libs/matcha/components/ButtonText/index.ts
var ButtonText = __webpack_require__(74870);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/UtilityNav/UtilityNav.views.ts


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}



var StyledTypography = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e12rge5s2"
} : 0)( true ? {
  name: "ti75j2",
  styles: "margin:0"
} : 0);
var StyledButtonText = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(ButtonText/* default */.Z,  true ? {
  target: "e12rge5s1"
} : 0)("padding-top:3px;margin:0 8px;font-size:", function (_ref) {
  var theme = _ref.theme;
  return theme.typography.buttonSmall;
}, ";&:after{height:1px;bottom:4px;}" + ( true ? "" : 0));
var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e12rge5s0"
} : 0)("width:100%;text-align:center;background:", function (_ref2) {
  var background = _ref2.background;
  return background;
}, ";padding:7px 17px;", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.up("xs");
}, "{padding:17px 40px;}" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/UtilityNav/UtilityNav.tsx


var _excluded = ["announcement", "tokens"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}







var UtilityNavBase = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var announcement = _ref.announcement,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var utilityNavDescriptions = "";

  if (typeof (announcement === null || announcement === void 0 ? void 0 : announcement.description) === "string") {
    utilityNavDescriptions = announcement.description;
  } else if (announcement !== null && announcement !== void 0 && announcement.description) {
    utilityNavDescriptions = UtilityNav_useUtilityNavDescriptions(announcement.description);
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, _objectSpread(_objectSpread({}, rest), {}, {
    ref: ref,
    background: tokens.background,
    children: [utilityNavDescriptions && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledTypography, {
      variant: "buttonSmall",
      children: utilityNavDescriptions
    }), announcement && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledButtonText, {
      tokens: _objectSpread({}, tokens.buttonText),
      size: "small",
      href: announcement.ctaLink,
      hover: true,
      children: announcement.ctaTitle
    })]
  }));
});
var UtilityNav = (0,useDesignTokens/* withDesignTokens */.Y)(UtilityNavBase, function () {
  return {};
}, {
  twilioLight: function twilioLight(theme) {
    return {
      background: theme.palette.twilio.gray[10],
      buttonText: {
        textColor: theme.palette.twilio.gray[100],
        hoverColor: theme.palette.twilio.gray[100]
      }
    };
  },
  light: function light(theme) {
    return {
      background: theme.palette.twilio.gray[10],
      buttonText: {
        textColor: theme.palette.twilio.gray[100],
        hoverColor: theme.palette.twilio.gray[100]
      }
    };
  },
  dark: function dark(theme) {
    return {
      background: theme.palette.twilio.gray[10],
      buttonText: {
        textColor: theme.palette.twilio.gray[100],
        hoverColor: theme.palette.twilio.gray[100]
      }
    };
  }
});
/* harmony default export */ var UtilityNav_UtilityNav = (UtilityNav);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/UtilityNav/index.ts


/***/ }),

/***/ 31714:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MI": function() { return /* binding */ SignupButton; },
/* harmony export */   "_f": function() { return /* binding */ SignupButtonText; }
/* harmony export */ });
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82269);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _segment_matcha_components_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33445);
/* harmony import */ var _segment_matcha_components_ButtonText__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74870);
/* harmony import */ var _segment_contexts_page__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17782);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52903);


var _excluded = ["color", "variant", "size", "expanded", "children", "additionalParams", "linkToApp"],
    _excluded2 = ["appearance", "children", "additionalParams", "linkToApp"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}







var useTransformUrl = function useTransformUrl(customQuery, linkToApp) {
  var _usePageConfig = (0,_segment_contexts_page__WEBPACK_IMPORTED_MODULE_4__/* .usePageConfig */ .Gm)(),
      queryParamsFromCookie = _usePageConfig.queryParamsFromCookie,
      appUrl = _usePageConfig.appUrl;

  var hostUrl = linkToApp ? appUrl : "https://segment.com";
  var queryString = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    var query = new URLSearchParams(queryParamsFromCookie);

    for (var qs in customQuery) {
      query.append(qs, customQuery[qs]);
    }

    return query.toString() ? "?".concat(query.toString()) : "";
  }, [queryParamsFromCookie, customQuery]);
  return "".concat(hostUrl, "/signup/").concat(queryString);
};

var SignupButton = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function (_ref, ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "primary" : _ref$color,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "filled" : _ref$variant,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "large" : _ref$size,
      expanded = _ref.expanded,
      children = _ref.children,
      additionalParams = _ref.additionalParams,
      _ref$linkToApp = _ref.linkToApp,
      linkToApp = _ref$linkToApp === void 0 ? false : _ref$linkToApp,
      rest = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref, _excluded);

  var url = useTransformUrl(additionalParams, linkToApp);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_segment_matcha_components_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread(_objectSpread({
    variant: variant,
    size: size,
    color: color,
    expanded: expanded,
    tag: "a",
    href: url,
    ref: ref
  }, rest), {}, {
    children: children
  }));
});
var SignupButtonText = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function (_ref2, ref) {
  var externalAppearance = _ref2.appearance,
      children = _ref2.children,
      additionalParams = _ref2.additionalParams,
      _ref2$linkToApp = _ref2.linkToApp,
      linkToApp = _ref2$linkToApp === void 0 ? false : _ref2$linkToApp,
      rest = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref2, _excluded2);

  var url = useTransformUrl(additionalParams, linkToApp);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_segment_matcha_components_ButtonText__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, _objectSpread(_objectSpread({
    ref: ref,
    href: url,
    appearance: externalAppearance
  }, rest), {}, {
    children: children
  }));
});
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (SignupButton)));

/***/ }),

/***/ 77931:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _SignupButton__WEBPACK_IMPORTED_MODULE_0__.MI; },
/* harmony export */   "_": function() { return /* reexport safe */ _SignupButton__WEBPACK_IMPORTED_MODULE_0__._f; }
/* harmony export */ });
/* harmony import */ var _SignupButton__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31714);


/***/ }),

/***/ 56052:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Layout__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Layout__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6372);


/***/ }),

/***/ 22761:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ NavigationBrand_NavigationBrand; }
});

// EXTERNAL MODULE: ../../libs/matcha/components/Media/index.ts + 2 modules
var Media = __webpack_require__(75091);
// EXTERNAL MODULE: ../../libs/matcha/components/SegmentLogo/index.ts + 2 modules
var SegmentLogo = __webpack_require__(84672);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/UtilityNav/index.ts + 3 modules
var UtilityNav = __webpack_require__(90629);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/index.ts + 30 modules
var Navigation_MobileNavigation = __webpack_require__(86943);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/Navbar/index.ts + 8 modules
var Navbar = __webpack_require__(90806);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/NavigationBrand/MobileNavigation.tsx







var MobileNavigation = function MobileNavigation(_ref) {
  var announcement = _ref.announcement,
      backgroundColor = _ref.backgroundColor;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Navigation_MobileNavigation/* default */.ZP, {
    children: [announcement && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UtilityNav/* default */.Z, {
      announcement: announcement
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation_MobileNavigation/* Navbar */.wp, {
      tokens: {
        backgroundColor: backgroundColor
      },
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navbar/* Brand */.H2, {
        href: "/",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SegmentLogo/* default */.Z, {
          alt: "Twilio, Inc."
        })
      })
    })]
  });
};

/* harmony default export */ var NavigationBrand_MobileNavigation = (MobileNavigation);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Navigation/DesktopNavigation/Navbar/index.ts + 14 modules
var DesktopNavigation_Navbar = __webpack_require__(77966);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Navigation/DesktopNavigation/index.ts + 24 modules
var DesktopNavigation = __webpack_require__(82680);
;// CONCATENATED MODULE: ../../libs/templates/NavigationBrand/DesktopNavigation.tsx






var DesktopNavigation_MobileNavigation = function MobileNavigation(_ref) {
  var announcement = _ref.announcement,
      backgroundColor = _ref.backgroundColor;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(DesktopNavigation/* default */.ZP, {
    children: [announcement && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DesktopNavigation/* UtilityNav */.T8, {
      announcement: announcement
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DesktopNavigation/* Navbar */.wp, {
      tokens: {
        backgroundColor: backgroundColor
      },
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DesktopNavigation_Navbar/* Brand */.H2, {
        href: "/",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SegmentLogo/* default */.Z, {
          alt: "Twilio, Inc."
        })
      })
    })]
  });
};

/* harmony default export */ var NavigationBrand_DesktopNavigation = (DesktopNavigation_MobileNavigation);
;// CONCATENATED MODULE: ../../libs/templates/NavigationBrand/NavigationBrand.tsx






var NavigationBrand = function NavigationBrand(_ref) {
  var announcement = _ref.announcement,
      backgroundColor = _ref.backgroundColor;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Media/* default */.Z, {
      greaterThanOrEqual: "md",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavigationBrand_DesktopNavigation, {
        backgroundColor: backgroundColor,
        announcement: announcement
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Media/* default */.Z, {
      lessThan: "md",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavigationBrand_MobileNavigation, {
        backgroundColor: backgroundColor,
        announcement: announcement
      })
    })]
  });
};
/* harmony default export */ var NavigationBrand_NavigationBrand = (NavigationBrand);
;// CONCATENATED MODULE: ../../libs/templates/NavigationBrand/index.ts


/***/ }),

/***/ 34689:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/the-growth-report",
      function () {
        return __webpack_require__(94188);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 49534:
/***/ (function(module) {

module.exports = "/_next/static/images/OgGrowthReport-ff0a58a87b99f7ccec5d67ace5e050a1.png";

/***/ }),

/***/ 85045:
/***/ (function(module) {

module.exports = "/_next/static/images/Hero@2x-7ffa016f7979a7e5afeee44f72fa5afd.png";

/***/ }),

/***/ 71236:
/***/ (function(module) {

module.exports = "/_next/static/images/Frame-df8e92054de8de5452b2f05384675411.png";

/***/ }),

/***/ 39584:
/***/ (function(module) {

module.exports = "/_next/static/images/Frame2-684c4e51d9a3b33131df2c1f86196301.png";

/***/ }),

/***/ 18955:
/***/ (function(module) {

module.exports = "/_next/static/images/Frame2Mobile-dcf0c7803304b6fd52ec0c806a77fd31.png";

/***/ }),

/***/ 2313:
/***/ (function(module) {

module.exports = "/_next/static/images/FrameMobile-f68a36802ee89a9d5fef73e0e66ff883.png";

/***/ }),

/***/ 88173:
/***/ (function(module) {

module.exports = "/_next/static/images/Frame-f8025dfdebfa4fbe3d75af7da18b8ac9.png";

/***/ }),

/***/ 71463:
/***/ (function(module) {

module.exports = "/_next/static/images/FrameMobile-8e800ec336be9ea6b90eff93a69d19f7.png";

/***/ }),

/***/ 43077:
/***/ (function(module) {

module.exports = "/_next/static/images/Frame-33e9f16f9f1cb7340f2af07f09365a2c.png";

/***/ }),

/***/ 89860:
/***/ (function(module) {

module.exports = "/_next/static/images/FrameMobile-1e2deed2937e90116bafa3571afd28d6.png";

/***/ }),

/***/ 73304:
/***/ (function(module) {

module.exports = "/_next/static/images/Frame-7a6eb91742fedcf16f70560ca3bb74dd.png";

/***/ }),

/***/ 8164:
/***/ (function(module) {

module.exports = "/_next/static/images/Frame2-e71144f67e76e3318a4922a818581a28.png";

/***/ }),

/***/ 11455:
/***/ (function(module) {

module.exports = "/_next/static/images/Frame2Mobile-6a7eab711edce38d42d5f691cb6f72e5.png";

/***/ }),

/***/ 62072:
/***/ (function(module) {

module.exports = "/_next/static/images/FrameMobile-8ef47991ce2f28ec350cf497dee5301e.png";

/***/ }),

/***/ 14210:
/***/ (function(module) {

module.exports = "/_next/static/images/Hero-f8d528414abc93ef041998ff30ff56ae.webp";

/***/ }),

/***/ 32719:
/***/ (function(module) {

module.exports = "/_next/static/images/Hero@2x-971e4400f6dbee06ba4760e42fa518f5.webp";

/***/ }),

/***/ 53583:
/***/ (function(module) {

module.exports = "/_next/static/images/Frame-cc12d182c1a8bad0c9fb87047a22bcd6.webp";

/***/ }),

/***/ 45500:
/***/ (function(module) {

module.exports = "/_next/static/images/Frame2-302cab68f4d676cfc86415887d16f7bf.webp";

/***/ }),

/***/ 65752:
/***/ (function(module) {

module.exports = "/_next/static/images/Frame2Mobile-0477e02adb719f215dc00c192d6ac0ab.webp";

/***/ }),

/***/ 64609:
/***/ (function(module) {

module.exports = "/_next/static/images/FrameMobile-8b40d86aa157da74406bb08669b0019c.webp";

/***/ }),

/***/ 56150:
/***/ (function(module) {

module.exports = "/_next/static/images/Frame-38a739dc725afa4e58af9c9de5d7a9dc.webp";

/***/ }),

/***/ 14248:
/***/ (function(module) {

module.exports = "/_next/static/images/FrameMobile-40d9008bc0c8393b35969e0a9a5e3f61.webp";

/***/ }),

/***/ 17235:
/***/ (function(module) {

module.exports = "/_next/static/images/Frame-07d1480bbcf04ad93b1b247aaf1053d6.webp";

/***/ }),

/***/ 65947:
/***/ (function(module) {

module.exports = "/_next/static/images/FrameMobile-bd45ed8a2751277d1278e5a5bb7f682e.webp";

/***/ }),

/***/ 30475:
/***/ (function(module) {

module.exports = "/_next/static/images/Frame-b8da18d4b80649380e00b13cac58c5e2.webp";

/***/ }),

/***/ 32178:
/***/ (function(module) {

module.exports = "/_next/static/images/Frame2-9e5756127a1115c698ed1fc880d08224.webp";

/***/ }),

/***/ 5080:
/***/ (function(module) {

module.exports = "/_next/static/images/Frame2Mobile-150a3a16d99027ffccfb9b217f30d9ca.webp";

/***/ }),

/***/ 16522:
/***/ (function(module) {

module.exports = "/_next/static/images/FrameMobile-484225fb210a2ab0ceb3022a5c432867.webp";

/***/ }),

/***/ 76527:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 96969:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 32232:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 24195:
/***/ (function() {

/* (ignored) */

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3287,9097,6577,9137,3254,9129,8834,4330,1382,4136,2073,8392,2429,948,3996,7947,7960,6012,9524,5979,9774,2888,179], function() { return __webpack_exec__(34689); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);